import React, { useState } from "react";
import { Box, TextField, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import PrintIcon from "@mui/icons-material/Print";
import ParentingTimeCalendar from "../../components/parentingTimeCalendar/ParentingTimeCalendar";

const ParentingTimeCalendarPage: React.FC = () => {
  const { t } = useTranslation();
  const [parent1, setParent1] = useState("Parent 1");
  const [parent2, setParent2] = useState("Parent 2");
  const [nonCustodial, setNonCustodial] = useState("Parent 1");
  const [calendarData, setCalendarData] = useState<Record<string, string>>({});

  return (
    <Box sx={{ maxWidth: 1200, mx: "auto", p: 3 }}>
      <Typography variant="h3" textAlign="center" mb={3} color="#0464AB" sx={{ fontWeight: 600 }}>
        {t("Parenting Time Calendar Tool")}
      </Typography>
      <ParentingTimeCalendar
        parentName1={parent1}
        parentName2={parent2}
        nonCustodialParent={nonCustodial}
        calendarData={calendarData}
        onCalendarChange={setCalendarData}
        parentFields={
          <Box sx={{ display: "flex", gap: 2, mb: 3, justifyContent: "center", flexWrap: "wrap" }}>
            <TextField
              size="small"
              label={t("Parent 1 Name")}
              value={parent1}
              onChange={(e) => {
                setParent1(e.target.value);
                if (nonCustodial === "Parent 1") setNonCustodial(e.target.value);
              }}
              InputProps={{ sx: { minHeight: 44 } }}
            />
            <TextField
              size="small"
              label={t("Parent 2 Name")}
              value={parent2}
              onChange={(e) => setParent2(e.target.value)}
              InputProps={{ sx: { minHeight: 44 } }}
            />
            <Button
              variant="outlined"
              startIcon={<PrintIcon />}
              onClick={() => window.print()}
              sx={{
                minHeight: 44,
                minWidth: 44,
                color: "#0B57A0",
                borderColor: "#0B57A0",
                "&:hover": { borderColor: "#083D73", color: "#083D73" },
                "@media print": { display: "none" },
              }}
            >
              {t("Print")}
            </Button>
          </Box>
        }
      />
    </Box>
  );
};

export default ParentingTimeCalendarPage;
